export const mobileMenuAccordion = ()=> {
    const hasDropdownsMobile = document.querySelectorAll('.mobile__nav .has-dropdown')

    hasDropdownsMobile?.forEach(dropdown=> {
        if (dropdown.querySelector('.sub-menu')) {
            const dropdownLink = dropdown.querySelector('.has-dropdown > a')
            let hiddenPart = dropdown.querySelector('.has-dropdown > .sub-menu');

            dropdownLink.addEventListener('click',(e)=> {
                e.preventDefault();
                let hiddenPartHeight = hiddenPart.scrollHeight;
                dropdown?.classList.toggle("active");

                dropdown?.classList.contains("active") ? hiddenPart.style.maxHeight = hiddenPartHeight + 'px' : hiddenPart.style.maxHeight = null
            })
        }
    })


}